import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// project import
// import useAuth from 'hooks/useAuth';
import { useSelector } from 'react-redux';
// import usePermission from 'hooks/usePermission';

// ==============================|| AUTH GUARD ||============================== //

const AuthGuard = ({ children }) => {
  const { isLoggedIn } = useSelector((state) => state.auth);
  // const { getRoutePermission } = usePermission();
  // const params = useParams();

  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    if (!isLoggedIn) {
      navigate('login', {
        state: {
          from: location.pathname
        },
        replace: true
      });
      navigate('login', { replace: true });
    } else {
      console.log('IN AUTHGUARD');
      // if (!getRoutePermission(location.pathname, params?.id)) {
      //   navigate('maintenance/404', {
      //     state: {
      //       from: location.pathname
      //     },
      //     replace: true
      //   });
      // }
    }
  }, [location.pathname, navigate, location]);

  return children;
};

AuthGuard.propTypes = {
  children: PropTypes.node
};

export default AuthGuard;
